import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

// Remove "Made with Emergent" badge if it gets injected
const removeBadge = () => {
  try {
    // Remove anchors that link to emergent
    document.querySelectorAll('a[href*="emergent.sh"], a[href*="emergent.host"], a[href*="emergent.com"]').forEach((el) => {
      const txt = (el.textContent || "").toLowerCase();
      if (txt.includes("made with") || txt.includes("emergent") || el.closest('[style*="position: fixed"]')) {
        el.remove();
      }
    });
    // Remove iframes
    document.querySelectorAll('iframe[src*="emergent"]').forEach((el) => el.remove());
    // Remove any element whose text is exactly "Made with Emergent"
    document.querySelectorAll('div, span, a').forEach((el) => {
      if (el.children.length === 0 && /made with emergent/i.test(el.textContent || "")) {
        const fixed = el.closest('[style*="position: fixed"], [style*="position:fixed"]');
        (fixed || el).remove();
      }
    });
  } catch (e) { /* noop */ }
};

if (typeof window !== "undefined") {
  // Initial sweep
  setTimeout(removeBadge, 500);
  setTimeout(removeBadge, 1500);
  setTimeout(removeBadge, 3000);
  // Watch DOM for re-injection
  if (window.MutationObserver) {
    const observer = new MutationObserver(removeBadge);
    document.addEventListener("DOMContentLoaded", () => {
      observer.observe(document.body, { childList: true, subtree: true });
    });
  }
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
